import { BookmarkPlusOutlineIcon } from './BookmarkPlusOutlineIcon';

/**
 * author: Google
 * id DB2B7624-66CB-4E7E-A65F-4CEE8870C6CC
 * name bookmark-plus-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-plus-outline.svg
 * tags
 */
export const BookmarkAddOutlineIcon = BookmarkPlusOutlineIcon;
export default BookmarkAddOutlineIcon